<div class="c-portlet o-block  u-shadow-mini  white-bg" style="position: relative; width: 100%;">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini" style="padding: 10px 20px; width: 100%;">
        <div class="o-stack__cell">
            <h5>{{sectiontitle}}</h5>
        </div>
    </div>

    <div class="c-portlet__content" style="height: 360px; width: 100%;">
        <div class="lift-chart-grid" *ngIf="campaignsArray.length">
            <div class="lift-trend-width">
                <div *ngIf="campaignsArray.length > 1">
                    <div #chartElement class="charts-container">
                        <div *ngFor="let campaign of campaignsArray; let i = index" class="chart-layout">
                            <div [id]="'campaign'+i" class="individual-chart" style="min-height: 200px;">
                                <app-chart class="individual-chart" [chartData]="campaign"></app-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="campaignsArray.length === 1">
                    <div class="campaign-details-container">
                        <div class="campaign-name">{{campaignsArray[0].name}}</div>
                        <div class="campaign-subdetail-conatiner">
                            <div class="campaign-subdetail-type">Lift</div>
                            <div class="campaign-subdetail-value"> {{campaignsArray[0].average_lift}}x Lift</div>
                        </div>
                        <div class="campaign-subdetail-conatiner">
                            <div class="campaign-subdetail-type">Exposed Rate</div>
                            <div class="campaign-subdetail-value">{{campaignsArray[0].average_exposed_rate}}%</div>
                        </div>
                        <div class="campaign-subdetail-conatiner">
                            <div class="campaign-subdetail-type">Baseline Rate</div>
                            <div class="campaign-subdetail-value">{{campaignsArray[0].average_baseline}}%</div>
                        </div>
                    </div>
                    <div class="campaign-detail-chart">
                        <app-chart [chartData]="campaignsArray[0]"></app-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="lift-trend-no-data-body" *ngIf="!campaignsArray.length" >
            <img [src]="placeholderimage" class="lift-trend-no-data-placeholder" />
        </div>
    </div>
</div>
